import pricingLogo1 from './pricing_logo1.png';
import pricingLogo2 from './pricing_logo2.jpg';
import pricingLogo3 from './pricing_logo3.png';
import graphics from './graphics.svg';
export { pricingLogo1, pricingLogo2, pricingLogo3, graphics };
